module.exports = __webpack_public_path__ + "src/images/logos/logo-invoice.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logos/logo-invoice.svg
 ** module id = 1575
 ** module chunks = 1
 **/